import QuotationComponent from './quotation';
export default QuotationComponent;
